module.exports = __webpack_public_path__ + "img/ic_system_bottom.4cde3f5b.png";